import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";

const profileOptions = [
  { value: "CUSTOMER", label: "Customer" },
  { value: "OPERATION", label: "Operation" },
];

const statusOptions = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
  { value: "2", label: "New User" },
  { value: "3", label: "Blocked" },
  { value: "5", label: "Awaiting Customer Authorization" },
];

const UserFilterModal = ({
  show,
  handleClose,
  setUserData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      ...filterData,
      userProfile: filterData.userProfile || null,
      status: filterData.status || null,
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
      name: filterData.name || "",
      emailId: filterData.emailId || "",
      mobileNo: filterData.mobileNo || "",
    },
    mode: "onChange",
  });
  const loggedInUserName = sessionStorage.getItem("username");
  const userRole = sessionStorage.getItem("userRole");
  const isCust = userRole === "CUST";

  const [selectedTab, setSelectedTab] = useState("User Id");
  const [loading, setLoading] = useState(false);
  const [customerNameOpen, setCustomerNameOpen] = useState(false);
  const [customerList, setCustomerList] = useState([]);

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchCustomerData(currentPage, data);
  };

  const fetchCustomerData = async (page, formData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userId: formData.userId || "",
        userProfile: formData.userProfile?.value || "",
        status: formData.status?.value || "",
        fromDate: formatDate(formData.fromDate),
        toDate: formatDate(formData.toDate),
        name: formData.name || "",
        emailId: formData.emailId || "",
        mobileNo: formData.mobileNo || "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_USER_DATA}?pageSize=${pageSize}&pageNo=${page}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setUserData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setUserData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((customer, index) => ({
      ...customer,
      id: index + 1,
      address:
        customer.address1 + ", " + customer.address2 + ", " + customer.address3,
    }));
  };

  const onReset = () => {
    reset({
      userId: "",
      userProfile: null,
      status: null,
      fromDate: "",
      toDate: "",
      name: "",
      emailId: "",
      mobileNo: "",
    });
    setFilterData({
      userId: "",
      userProfile: null,
      status: null,
      fromDate: "",
      toDate: "",
      name: "",
      emailId: "",
      mobileNo: "",
    });
    handleReset();
  };

  const toggleCustomerNameDropdown = () =>
    setCustomerNameOpen(!customerNameOpen);

  useEffect(() => {
    fetchActiveCustomerData();
  }, []);

  const fetchActiveCustomerData = async () => {
    try {
      const response = await axiosGetApi(apiList.ALL_ACTIVE_CUSTOMER_DATA);

      if (response?.status === 200) {
        setCustomerList(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <h5 className="modal-title main-title">Filter</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "User Id",
                        "Profile",
                        "Status",
                        "Created Date",
                        "Company Name",
                        "User Email Id",
                        "User Mobile No",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "User Id" && (
                        <Controller
                          name="userId"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">User ID</label>
                              <input
                                {...field}
                                type="text"
                                placeholder="Enter User ID"
                                className="dateInput"
                                maxLength={20}
                                onChange={(e) => {
                                  const val = e.target.value.replace(
                                    /[^a-zA-Z0-9]/g,
                                    ""
                                  );
                                  field.onChange(val);
                                  setFilterData((prev) => ({
                                    ...prev,
                                    userId: val,
                                  }));
                                }}
                              />
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Profile" && (
                        <Controller
                          name="userProfile"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Profile</label>
                              <div className="dateInputWrapper">
                                <select
                                  {...field}
                                  value={field.value?.value || ""}
                                  onChange={(e) => {
                                    const selected = profileOptions.find(
                                      (opt) => opt.value === e.target.value
                                    );
                                    field.onChange(selected || null);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      userProfile: selected || null,
                                    }));
                                  }}
                                  className="dateInput"
                                >
                                  <option value="">Select Profile</option>
                                  {profileOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Status" && (
                        <Controller
                          name="status"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Status</label>
                              <div className="dateInputWrapper">
                                <select
                                  {...field}
                                  value={field.value?.value || ""}
                                  onChange={(e) => {
                                    const selected = statusOptions.find(
                                      (opt) => opt.value === e.target.value
                                    );
                                    field.onChange(selected || null);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: selected || null,
                                    }));
                                  }}
                                  className="dateInput"
                                >
                                  <option value="">Select Status</option>
                                  {statusOptions.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <span className="error-text">
                                      {errors.fromDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <span className="error-text">
                                      {errors.toDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Company Name" &&
                        (isCust ? (
                          <Controller
                            name="name"
                            control={control}
                            render={({ field }) => (
                              <div className="dateField">
                                <label className="dateLabel">
                                  Company Name
                                </label>
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Company Name"
                                  className="dateInput"
                                  maxLength={50}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      name: e.target.value,
                                    }));
                                  }}
                                />
                              </div>
                            )}
                          />
                        ) : (
                          <>
                            <div className="form-group position-relative">
                              <select
                                className="form-control select-dropdown"
                                id="name"
                                placeholder="Role"
                                onClick={toggleCustomerNameDropdown}
                                value={filterData.companyId || ""}
                                onChange={(e) => {
                                  const selectedCode = e.target.value;
                                  const selectedCustomer = customerList.find(
                                    (customer) =>
                                      customer.customerCode === selectedCode
                                  );

                                  // Save customerCode for backend
                                  setFilterData((prev) => ({
                                    ...prev,
                                    companyId:
                                      selectedCustomer?.customerCode || "",
                                    name: selectedCustomer?.name || "",
                                  }));

                                  // Optional: if using react-hook-form
                                  setValue(
                                    "companyId",
                                    selectedCustomer?.customerCode || ""
                                  );
                                  setValue(
                                    "name",
                                    selectedCustomer?.name || ""
                                  );
                                }}
                              >
                                <option value="" disabled selected>
                                  Select Company Name
                                </option>
                                {customerList?.map((customer) => {
                                  return (
                                    <option
                                      key={customer.customerCode}
                                      value={customer.customerCode}
                                    >
                                      {customer.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <span className="position-absolute select-icon">
                                {customerNameOpen ? (
                                  <ChevronUp />
                                ) : (
                                  <ChevronDownIcon />
                                )}
                              </span>
                            </div>
                            {errors.customerName ? (
                              <span className="error">
                                {errors.customerName}
                              </span>
                            ) : null}
                          </>
                        ))}

                      {selectedTab === "User Email Id" && (
                        <Controller
                          name="emailId"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">User Email Id</label>
                              <input
                                {...field}
                                type="email"
                                placeholder="Enter User Email Id"
                                className="dateInput"
                                maxLength={100}
                                onChange={(e) => {
                                  field.onChange(e);
                                  setFilterData((prev) => ({
                                    ...prev,
                                    emailId: e.target.value,
                                  }));
                                }}
                              />
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "User Mobile No" && (
                        <Controller
                          name="mobileNo"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">
                                User Mobile No
                              </label>
                              <input
                                {...field}
                                type="tel"
                                placeholder="Enter User Mobile No"
                                className="dateInput"
                                maxLength={15}
                                onChange={(e) => {
                                  const val = e.target.value.replace(
                                    /[^0-9+-\s]/g,
                                    ""
                                  );
                                  field.onChange(val);
                                  setFilterData((prev) => ({
                                    ...prev,
                                    mobileNo: val,
                                  }));
                                }}
                              />
                            </div>
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UserFilterModal;
